import { createAction, props } from "@ngrx/store";


export const fetchTopBanners = createAction(
  "[Top Banner] Fetch Top Banners"
);

export const fetchTopBannersSuccess = createAction(
  "[Top Banner] Fetch Top Banners Success",
  props<{ topBanner }>()
);

export const fetchTopBannersFailure = createAction(
  "[Top Banner] Fetch Top Banners Faild",
  props<{ error }>()
);

export const fetchLastUpdates = createAction(
  "[Last Updates] Fetch Last Updates",
);

export const fetchLastUpdatesSuccess = createAction(
  "[Last Updates] Fetch Last Updates Success",
  props<{ payload }>()
);

export const fetchLastUpdatesFailure = createAction(
  "[Last Updates] Fetch Last Updates Faild",
  props<{ error }>()
);

export const fetchGroupDetails = createAction(
  "[Group Details] Fetch Last Updates",
  props<{ payload }>()
);

export const fetchGroupDetailsSuccess = createAction(
  "[Group Details] Fetch Group Details Success",
  props<{ payload }>()
);

export const fetchGroupDetailsFailure = createAction(
  "[Group Details] Fetch Group Details Faild",
  props<{ error }>()
);
